document.addEventListener('DOMContentLoaded', function () {
    const calculatorContainer = document.querySelector('.calculator')
    const toggleCalculatorBtn = document.getElementById('toggleCalculator')
    const devicesSlider = document.getElementById('backup_devices')
    const storageSlider = document.getElementById('backup_storage')
    const link = document.querySelector('.calculator a')
    const pricePart1 = document.querySelector('#backup_plan_advanced .price-part-1')
    const pricePart2 = document.querySelector('#backup_plan_advanced .price-part-2')

    const BASE_PRICE = 20.75 // Base price in BGN for the plan
    const STORAGE_PRICE_PER_1000GB = 13.25 // Additional price in BGN for every 1000 GB of storage
    const DEVICE_PRICE_PER_UNIT = 4 // Additional price in BGN for every 1 more device

    function updateValue() {
        const slider = this.querySelector('.slider')
        const valueElement = this.querySelector('.value')
        valueElement.textContent = slider.value
    }

    function updateLinkAndPrice() {
        const devicesValue = parseInt(devicesSlider.value)
        const storageValue = parseInt(storageSlider.value)

        const devicesPrice = devicesValue > 2 ? (devicesValue - 2) * DEVICE_PRICE_PER_UNIT : 0
        const storagePrice = storageValue > 1000 ? Math.ceil((storageValue - 1000) / 1000) * STORAGE_PRICE_PER_1000GB : 0

        const totalPrice = BASE_PRICE + devicesPrice + storagePrice
        const levs = Math.floor(totalPrice)
        const pennies = (totalPrice - levs).toFixed(2).substring(2)

        pricePart1.textContent = levs
        pricePart2.textContent = `.${pennies}`

        const url = new URL(link.href)
        url.searchParams.set('custom[1890][10498]', devicesValue)
        url.searchParams.set('custom[1891][10499]', storageValue)

        link.href = url.toString()
    }

    calculatorContainer.addEventListener('input', function (event) {
        if (event.target.classList.contains('slider')) {
            updateValue.call(event.target.closest('.slider-container'))
            updateLinkAndPrice()
        }
    })

    toggleCalculatorBtn.addEventListener('click', () => {
        const calculatorContainer = document.querySelector('.calculator')
        calculatorContainer.style.display = 'block'

        calculatorContainer.scrollIntoView({ behavior: 'smooth' })
    })

    devicesSlider.addEventListener('input', throttle(updateLinkAndPrice, 300))
    storageSlider.addEventListener('input', throttle(updateLinkAndPrice, 300))

    function throttle(callback, delay) {
        let lastTime = 0
        return function (...args) {
            const currentTime = new Date().getTime()
            if (currentTime - lastTime >= delay) {
                callback(...args)
                lastTime = currentTime
            }
        }
    }
})
